import React, { CSSProperties } from 'react';
import { useHistory } from 'react-router-dom';
import Colors from 'modules/Colors';
import Icon from 'elements/Icon'; // Import the Icon element
import useScreen from 'Hooks/useScreen';
import { styx } from 'modules/Utils';
import { ExternalSiteLinks } from 'modules/Const';


const Footer = () => {
    const history = useHistory();
    const { mStyle } = useScreen();


    const handleNavigation = (path: string) => {
        history.push(path);
    };

    const handleExternalNavigation = (url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const sitemapLinks = [
        { text: 'Home', path: '/', isExternal: false },
        { text: 'About Us', path: ExternalSiteLinks.ABOUT_US, isExternal: true },
        { text: 'Pricing', path: '/pricing', isExternal: false },
        { text: 'Partnerships', path: ExternalSiteLinks.PARTNERSHIPS, isExternal: true },
        { text: 'Case Studies', path: ExternalSiteLinks.CASE_STUDIES, isExternal: true },
        { text: 'Community Updates', path: ExternalSiteLinks.COMMUNITY_UPDATES, isExternal: true },
        { text: 'Referral Program', path: ExternalSiteLinks.REFERRAL_PROGRAM, isExternal: true },
        { text: 'Help Center', path: ExternalSiteLinks.HELP_CENTER, isExternal: true },
    ];

    const platformLinks = [
        { text: 'Maestro, your AI Marketing Agency', path: '/', isExternal: false },
        { text: 'Website Creation', path: ExternalSiteLinks.SOLUTIONS_WEBSITE_CREATION, isExternal: true },
        { text: 'Automated Ads', path: ExternalSiteLinks.SOLUTIONS_AUTOMATED_MARKETING, isExternal: true },
        { text: 'Cross-platform Analytics', path: ExternalSiteLinks.SOLUTIONS_CROSS_PLATFORM_ANALYTICS, isExternal: true },
        { text: 'Fan Growth & Insights', path: ExternalSiteLinks.SOLUTIONS_CROSS_PLATFORM_ANALYTICS, isExternal: true },
    ];

    const customerLinks = [
        { text: 'Artists', path: ExternalSiteLinks.CUSTOMERS_ARTISTS, isExternal: true },
        { text: 'Agencies', path: ExternalSiteLinks.CUSTOMERS_AGENCIES, isExternal: true },
        { text: 'Influencers & Content Creators', path: ExternalSiteLinks.CUSTOMERS_INFLUENCERS, isExternal: true },
        { text: 'Music Labels', path: ExternalSiteLinks.CUSTOMERS_MUSIC_LABELS, isExternal: true },
        { text: 'Managers', path: ExternalSiteLinks.CUSTOMERS_MANAGERS, isExternal: true },
        { text: 'Newsletter Writers', path: ExternalSiteLinks.CUSTOMERS_NEWSLETTERS, isExternal: true },
        { text: 'Podcasters', path: ExternalSiteLinks.CUSTOMERS_PODCASTERS, isExternal: true },
        { text: 'Small Business Owners', path: ExternalSiteLinks.CUSTOMERS_SMALL_BUSINESS, isExternal: true },
        { text: 'Teams', path: ExternalSiteLinks.CUSTOMERS_TEAMS, isExternal: true },
    ];

    const socialLinks = [
        { name: 'Instagram', url: ExternalSiteLinks.SOCIAL_INSTAGRAM, icon: 'instagramFlat' },
        { name: 'TikTok', url: ExternalSiteLinks.SOCIAL_TIKTOK, icon: 'tiktokFlat' },
        { name: 'Twitter', url: ExternalSiteLinks.SOCIAL_TWITTER, icon: 'xFlat' },
        { name: 'YouTube', url: ExternalSiteLinks.SOCIAL_YOUTUBE, icon: 'youtubeFlat' },
    ];

    const legalLinks = [
        { text: 'Terms of Service', path: ExternalSiteLinks.TERMS_OF_SERVICE },
        { text: 'Privacy Policy', path: ExternalSiteLinks.PRIVACY_POLICY },
        { text: 'Cancellation & Refund Policy', path: ExternalSiteLinks.CANCELLATION_REFUND_POLICY },
    ];

    return (
        <footer className={'mainAppFooter'} style={sty.footerContainer}>
            <div className="footerContent" style={mStyle(sty, 'footerContent')}>
                <div className="footerSocialSection" style={mStyle(sty, 'footerSection')}>
                    <h3 className="footerSectionTitle" style={sty.sectionTitle}>Follow Us</h3>
                    <ul className="footerSocialList" style={sty.socialList}>
                        {socialLinks.map((social, index) => (
                            <li key={index} className="footerSocialListItem" style={sty.socialListItem}>
                                <a 
                                    href={social.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="footerSocialLink" 
                                    style={sty.socialLink}
                                >
                                    <Icon className="footerSocialIcon" icon={social.icon} size={20} color={Colors.white} />
                                    <span className="footerSocialText" style={sty.socialText}>{social.name}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footerSitemapSection" style={mStyle(sty, 'footerSection')}>
                    <h3 className="footerSectionTitle" style={sty.sectionTitle}>Sitemap</h3>
                    <ul className="footerLinkList" style={sty.linkList}>
                        {sitemapLinks.map((link, index) => (
                            <li 
                                key={index}
                                className="footerLinkItem" 
                                style={sty.linkItem} 
                                onClick={() => link.isExternal ? handleExternalNavigation(link.path) : handleNavigation(link.path)}
                            >
                                {link.text}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footerPlatformSection" style={mStyle(sty, 'footerSection')}>
                    <h3 className="footerSectionTitle" style={sty.sectionTitle}>Platform</h3>
                    <ul className="footerLinkList" style={sty.linkList}>
                        {platformLinks.map((link, index) => (
                            <li 
                                key={index}
                                className="footerLinkItem" 
                                style={sty.linkItem} 
                                onClick={() => link.isExternal ? handleExternalNavigation(link.path) : handleNavigation(link.path)}
                            >
                                {link.text}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footerCustomersSection" style={mStyle(sty, 'footerSection')}>
                    <h3 className="footerSectionTitle" style={sty.sectionTitle}>Customers</h3>
                    <ul className="footerLinkList" style={sty.linkList}>
                        {customerLinks.map((link, index) => (
                            <li 
                                key={index}
                                className="footerLinkItem" 
                                style={sty.linkItem} 
                                onClick={() => link.isExternal ? handleExternalNavigation(link.path) : handleNavigation(link.path)}
                            >
                                {link.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="footerBottom" style={sty.footerBottom}>
                <p className="footerCopyrightText" style={sty.copyrightText}>&copy; {new Date().getFullYear()} SymphonyOS. All rights reserved.</p>
                <div className="footerLegalLinksContainer" style={sty.legalLinksContainer}>
                    {legalLinks.map((link, index) => (
                        <React.Fragment key={index}>
                            <a 
                                className="footerLegalLinkItem" 
                                style={sty.legalLinkItem} 
                                href={link.path} 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                {link.text}
                            </a>
                            {index < legalLinks.length - 1 && (
                                <span className="footerLegalLinkSeparator" style={sty.legalLinkSeparator}>|</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </footer>
    );
};

const sty: Record<string, CSSProperties> = {
    footerContainer: {
        backgroundColor: Colors.greyDarker,
        color: Colors.white,
        padding: '40px 20px',
        borderTop: `1px solid ${Colors.greyDark}`,
    },
    footerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        maxWidth: '1200px',
        margin: '0 auto',
        paddingBottom: '20px',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 20,
    },

    footerContent_mobile: {
        flexDirection: 'column',
        gap: 16,
        maxWidth: '100%',
    },

    footerSection: {
        margin: '0px',
        width: 'auto',
    },
    footerSection_mobile: {
        width: '100%',
    },
    sectionTitle: {
        fontSize: '18px',
        marginBottom: '15px',
        color: Colors.white,
        fontWeight: 500
    },
    linkList: {
        listStyle: 'none',
        padding: 0,
    },
    linkItem: {
        marginBottom: '10px',
        cursor: 'pointer',
        fontSize: '16px',
        color: Colors.greyLight,
        transition: 'color 0.2s ease',
    },
    socialList: {
        listStyle: 'none',
        padding: 0,
    },
    socialListItem: {
        marginBottom: '10px',
    },
    socialLink: {
        color: Colors.white,
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '16px',
        transition: 'color 0.2s ease',
    },
    socialText: {
        color: Colors.greyLight,
        fontWeight: 400,
    },
    footerBottom: {
        textAlign: 'center',
        paddingTop: '20px',
        borderTop: `1px solid ${Colors.greyDark}`,
        fontSize: '12px',
        color: Colors.greyLight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px', // Space between copyright and legal links
    },
    copyrightText: {
        margin: 0, // Reset default margin
    },
    legalLinksContainer: {
        display: 'flex',
        gap: '5px', // Space between separator and link
        alignItems: 'center',
        flexWrap: 'wrap', // Allow links to wrap on smaller screens
        justifyContent: 'center',
    },
    legalLinkItem: {
        color: Colors.greyLight,
        textDecoration: 'none',
        fontSize: '12px',
        transition: 'color 0.2s ease',
    },
    legalLinkSeparator: {
        color: Colors.greyLight,
        fontSize: '12px',
        margin: '0 5px', // Add some space around the separator
    },
};

export default Footer;
